export default __webpack_public_path__ + "static/media/gallery-4.a56eaea5.jpg";